import { Component, Input } from '@angular/core';

@Component({
	selector: 'connecting-spinner',
	templateUrl: './ConnectingSpinner.Component.html',
	standalone: false
})
export class ConnectingSpinnerComponent {
	@Input() public destination: string;
}
